import {
  SEGMENT_FIELD_TYPES,
  SEGMENT_TYPES,
  URL_MAX_LENGTH,
  IMAGE_POSITION_OPTIONS,
  field,
  visualStyleProperty,
  globalColorProperties,
  commonSegment
} from "./segmentRegistryCore";

const commerceSegments = {
  [SEGMENT_TYPES.SPOTLIGHT]: commonSegment({
    id: SEGMENT_TYPES.SPOTLIGHT,
    visibilityPath: "sections.showSpotlight",
    requiresProducts: true,
    elementEditingReady: true,
    visibilityCompanionPaths: ["catalog.spotlight.enabled"],
    visibilityLabel: "Mostrar destacado",
    shellVisualBackground: false,
    shellVisualPalette: false,
    shellPropertyPaths: [
      "catalog.spotlight.primaryColor",
      "catalog.spotlight.secondaryColor",
    ],
    properties: [
      field("sections.showSpotlight", SEGMENT_FIELD_TYPES.BOOLEAN, {
        label: "Permitir mostrar el bloque",
      }),
      field("catalog.spotlight.enabled", SEGMENT_FIELD_TYPES.BOOLEAN, {
        label: "Activar bloque destacado",
      }),
      field("catalog.spotlight.eyebrow", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Texto superior",
        maxLength: 180,
      }),
      field("catalog.spotlight.title", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Título",
        maxLength: 220,
      }),
      field("catalog.spotlight.description", SEGMENT_FIELD_TYPES.TEXTAREA, {
        label: "Descripción",
        maxLength: 1200,
      }),
      field("catalog.spotlight.logoUrl", SEGMENT_FIELD_TYPES.IMAGE, {
        label: "Logo o imagen principal",
        maxLength: URL_MAX_LENGTH,
        altPath: "catalog.spotlight.logoAlt",
      }),
      field("catalog.spotlight.logoAlt", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Texto alternativo del logo",
        maxLength: 220,
      }),
      field("catalog.spotlight.backgroundImageUrl", SEGMENT_FIELD_TYPES.IMAGE, {
        label: "Imagen de fondo",
        maxLength: URL_MAX_LENGTH,
        positionPath: "catalog.spotlight.backgroundImagePosition",
      }),
      field("catalog.spotlight.backgroundImagePosition", SEGMENT_FIELD_TYPES.SELECT, {
        label: "Posición de la imagen",
        options: IMAGE_POSITION_OPTIONS,
      }),
      field("catalog.spotlight.ctaLabel", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Botón destacado",
        maxLength: 100,
      }),
      field("catalog.spotlight.ctaUrl", SEGMENT_FIELD_TYPES.URL, {
        label: "Destino del botón",
        maxLength: URL_MAX_LENGTH,
        destinationPicker: true,
      }),
      field("catalog.spotlight.ctaRequiresProducts", SEGMENT_FIELD_TYPES.BOOLEAN, {
        label: "El botón requiere catálogo",
      }),
      field("catalog.spotlight.primaryColor", SEGMENT_FIELD_TYPES.COLOR, {
        label: "Color principal del destacado",
        maxLength: 100,
        colorScope: "section",
        fallbackPath: "theme.primaryColor",
      }),
      field("catalog.spotlight.secondaryColor", SEGMENT_FIELD_TYPES.COLOR, {
        label: "Color secundario del destacado",
        maxLength: 100,
        colorScope: "section",
        fallbackPath: "theme.secondaryColor",
      }),
      visualStyleProperty(SEGMENT_TYPES.SPOTLIGHT),
    ],
  }),
  [SEGMENT_TYPES.FEATURED]: commonSegment({
    id: SEGMENT_TYPES.FEATURED,
    visibilityPath: "sections.showFeatured",
    requiresProducts: true,
    elementEditingReady: true,
    shellVisualPalette: false,
    elementTargets: {
      "catalog.featured.ctaLabel": {
        kind: "button",
        label: "Botón de catálogo",
        labelPath: "catalog.featured.ctaLabel",
        chips: ["Catálogo"],
      },
      "@featured.cards": {
        kind: "card-system",
        label: "Cards del catálogo",
        fieldPrefix: "catalog.cards.",
        chips: ["Global"],
      },
    },
    shellAdvancedGroups: [
      {
        label: "Fondo",
        paths: ["catalog.featured.backgroundColor"],
      },
      {
        label: "Mensajes del catálogo",
        paths: [
          "catalog.featured.loadingText",
          "catalog.featured.emptyText",
          "catalog.featured.errorText",
        ],
      },
      {
        label: "Apariencia de mensajes",
        paths: [
          "catalog.featured.loadingTextColor",
          "catalog.featured.emptyTextColor",
          "catalog.featured.errorTextColor",
        ],
      },
    ],
    properties: [
      field("sections.showProducts", SEGMENT_FIELD_TYPES.BOOLEAN, {
        label: "Mostrar catálogo",
      }),
      field("sections.showFeatured", SEGMENT_FIELD_TYPES.BOOLEAN, {
        label: "Mostrar destacados",
      }),
      field("catalog.featured.eyebrow", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Texto superior",
        colorPath: "catalog.featured.eyebrowColor",
        maxLength: 180,
      }),
      field("catalog.featured.title", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Título",
        colorPath: "catalog.featured.titleColor",
        maxLength: 220,
      }),
      field("catalog.featured.subtitle", SEGMENT_FIELD_TYPES.TEXTAREA, {
        label: "Descripción",
        colorPath: "catalog.featured.subtitleColor",
        maxLength: 900,
      }),
      field("catalog.featured.loadingText", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Mensaje de carga",
        colorPath: "catalog.featured.loadingTextColor",
        maxLength: 220,
      }),
      field("catalog.featured.emptyText", SEGMENT_FIELD_TYPES.TEXTAREA, {
        label: "Mensaje sin resultados",
        colorPath: "catalog.featured.emptyTextColor",
        maxLength: 300,
      }),
      field("catalog.featured.errorText", SEGMENT_FIELD_TYPES.TEXTAREA, {
        label: "Mensaje de error",
        colorPath: "catalog.featured.errorTextColor",
        maxLength: 300,
      }),
      field("catalog.featured.ctaLabel", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Texto del botón",
        maxLength: 100,
      }),
      field("catalog.featured.backgroundColor", SEGMENT_FIELD_TYPES.COLOR, { label: "Fondo de la sección", defaultValue: "#FFFFFF", explicitVisual: true, maxLength: 100 }),
      field("catalog.featured.eyebrowColor", SEGMENT_FIELD_TYPES.COLOR, { label: "Color del texto superior", defaultValue: "#F35A3A", explicitVisual: true, maxLength: 100 }),
      field("catalog.featured.titleColor", SEGMENT_FIELD_TYPES.COLOR, { label: "Color del título", defaultValue: "#19242F", explicitVisual: true, maxLength: 100 }),
      field("catalog.featured.subtitleColor", SEGMENT_FIELD_TYPES.COLOR, { label: "Color de la descripción", defaultValue: "#5B5D73", explicitVisual: true, maxLength: 100 }),
      field("catalog.featured.loadingTextColor", SEGMENT_FIELD_TYPES.COLOR, { label: "Color del mensaje de carga", defaultValue: "#5B5D73", explicitVisual: true, maxLength: 100 }),
      field("catalog.featured.emptyTextColor", SEGMENT_FIELD_TYPES.COLOR, { label: "Color del mensaje sin resultados", defaultValue: "#1A1A2E", explicitVisual: true, maxLength: 100 }),
      field("catalog.featured.errorTextColor", SEGMENT_FIELD_TYPES.COLOR, { label: "Color del mensaje de error", defaultValue: "#D0333A", explicitVisual: true, maxLength: 100 }),
      field("catalog.cards.gap", SEGMENT_FIELD_TYPES.NUMBER, { label: "Separación entre cards", limits: { min: 0, max: 64, step: 1 }, uiGroup: "design" }),
      field("catalog.cards.radius", SEGMENT_FIELD_TYPES.NUMBER, { label: "Redondez de las cards", limits: { min: 0, max: 48, step: 1 }, uiGroup: "design" }),
      field("catalog.cards.backgroundColor", SEGMENT_FIELD_TYPES.COLOR, { label: "Fondo de las cards", maxLength: 100, colorScope: "section" }),
      field("catalog.cards.backgroundOpacity", SEGMENT_FIELD_TYPES.NUMBER, { label: "Transparencia del fondo", limits: { min: 0, max: 1, step: 0.05 }, uiGroup: "design" }),
      field("catalog.cards.backgroundImageUrl", SEGMENT_FIELD_TYPES.IMAGE, {
        label: "Imagen de fondo de las cards",
        maxLength: URL_MAX_LENGTH,
        positionPath: "catalog.cards.backgroundImagePosition",
      }),
      field("catalog.cards.backgroundImagePosition", SEGMENT_FIELD_TYPES.SELECT, {
        label: "Posición del fondo de las cards",
        options: IMAGE_POSITION_OPTIONS,
      }),
      field("catalog.cards.backgroundImageFit", SEGMENT_FIELD_TYPES.SELECT, {
        label: "Ajuste del fondo de las cards",
        options: [
          { value: "cover", label: "Cubrir la card" },
          { value: "contain", label: "Mostrar completa" },
        ],
        uiGroup: "design",
      }),
      field("catalog.cards.backgroundImageOpacity", SEGMENT_FIELD_TYPES.NUMBER, { label: "Opacidad de la imagen de fondo", limits: { min: 0, max: 1, step: 0.05 }, uiGroup: "design" }),
      field("catalog.cards.imagePosition", SEGMENT_FIELD_TYPES.SELECT, { label: "Posición de la foto del ítem", options: [
        { value: "top", label: "Arriba" }, { value: "left", label: "Izquierda" }, { value: "right", label: "Derecha" },
      ], uiGroup: "design" }),
      field("catalog.cards.imageFit", SEGMENT_FIELD_TYPES.SELECT, { label: "Comportamiento de la foto del ítem", options: [
        { value: "cover", label: "Cubrir" }, { value: "contain", label: "Contener completa" },
      ], uiGroup: "design" }),
      field("catalog.cards.imageHeight", SEGMENT_FIELD_TYPES.NUMBER, { label: "Alto de imagen", limits: { min: 90, max: 420, step: 5 }, uiGroup: "design" }),
      field("catalog.cards.showImage", SEGMENT_FIELD_TYPES.BOOLEAN, { label: "Mostrar imagen del ítem" }),
      field("catalog.cards.showTitle", SEGMENT_FIELD_TYPES.BOOLEAN, { label: "Mostrar nombre / título" }),
      field("catalog.cards.showButton", SEGMENT_FIELD_TYPES.BOOLEAN, { label: "Mostrar botón principal" }),
      field("catalog.cards.showType", SEGMENT_FIELD_TYPES.BOOLEAN, { label: "Mostrar tipo de ítem" }),
      field("catalog.cards.showCategory", SEGMENT_FIELD_TYPES.BOOLEAN, { label: "Mostrar categoría" }),
      field("catalog.cards.showSubcategory", SEGMENT_FIELD_TYPES.BOOLEAN, { label: "Mostrar subcategoría" }),
      field("catalog.cards.showDescription", SEGMENT_FIELD_TYPES.BOOLEAN, { label: "Mostrar descripción" }),
      field("catalog.cards.showPrice", SEGMENT_FIELD_TYPES.BOOLEAN, { label: "Mostrar precio" }),
      field("catalog.cards.showDuration", SEGMENT_FIELD_TYPES.BOOLEAN, { label: "Mostrar duración en servicios" }),
      field("catalog.cards.showCapabilities", SEGMENT_FIELD_TYPES.BOOLEAN, { label: "Mostrar reserva / entrega" }),
      field("catalog.cards.showQuickCart", SEGMENT_FIELD_TYPES.BOOLEAN, { label: "Mostrar compra rápida" }),
      field("catalog.cards.borderColor", SEGMENT_FIELD_TYPES.COLOR, { label: "Borde de la card", maxLength: 100, colorScope: "section" }),
      field("catalog.cards.shadowColor", SEGMENT_FIELD_TYPES.COLOR, { label: "Sombra de la card", maxLength: 100, colorScope: "section" }),
      field("catalog.cards.shadowOpacity", SEGMENT_FIELD_TYPES.NUMBER, { label: "Opacidad de la sombra", defaultValue: 1, limits: { min: 0, max: 1, step: 0.05 }, uiGroup: "design" }),
      field("catalog.cards.shadowX", SEGMENT_FIELD_TYPES.NUMBER, { label: "Sombra · desplazamiento X", defaultValue: 0, limits: { min: -100, max: 100, step: 1 }, uiGroup: "design" }),
      field("catalog.cards.shadowY", SEGMENT_FIELD_TYPES.NUMBER, { label: "Sombra · desplazamiento Y", defaultValue: 8, limits: { min: -100, max: 100, step: 1 }, uiGroup: "design" }),
      field("catalog.cards.shadowBlur", SEGMENT_FIELD_TYPES.NUMBER, { label: "Sombra · desenfoque", defaultValue: 24, limits: { min: 0, max: 160, step: 1 }, uiGroup: "design" }),
      field("catalog.cards.shadowSpread", SEGMENT_FIELD_TYPES.NUMBER, { label: "Sombra · expansión", defaultValue: 0, limits: { min: -80, max: 80, step: 1 }, uiGroup: "design" }),
      field("catalog.cards.typeColor", SEGMENT_FIELD_TYPES.COLOR, { label: "Color del tipo", maxLength: 100, colorScope: "section" }),
      field("catalog.cards.titleColor", SEGMENT_FIELD_TYPES.COLOR, { label: "Color del título", maxLength: 100, colorScope: "section" }),
      field("catalog.cards.categoryColor", SEGMENT_FIELD_TYPES.COLOR, { label: "Color de categoría", maxLength: 100, colorScope: "section" }),
      field("catalog.cards.subcategoryColor", SEGMENT_FIELD_TYPES.COLOR, { label: "Color de subcategoría", maxLength: 100, colorScope: "section" }),
      field("catalog.cards.descriptionColor", SEGMENT_FIELD_TYPES.COLOR, { label: "Color de descripción", maxLength: 100, colorScope: "section" }),
      field("catalog.cards.priceColor", SEGMENT_FIELD_TYPES.COLOR, { label: "Color del precio", maxLength: 100, colorScope: "section" }),
      field("catalog.cards.buttonTextColor", SEGMENT_FIELD_TYPES.COLOR, { label: "Texto del botón", maxLength: 100, colorScope: "section" }),
      field("catalog.cards.buttonBackgroundColor", SEGMENT_FIELD_TYPES.COLOR, { label: "Fondo del botón", maxLength: 100, colorScope: "section" }),
      field("catalog.cards.buttonHoverTextColor", SEGMENT_FIELD_TYPES.COLOR, { label: "Texto del botón al pasar el mouse", maxLength: 100, colorScope: "section" }),
      field("catalog.cards.buttonHoverBackgroundColor", SEGMENT_FIELD_TYPES.COLOR, { label: "Fondo del botón al pasar el mouse", maxLength: 100, colorScope: "section" }),
      field("catalog.cards.ctaLabel", SEGMENT_FIELD_TYPES.TEXT, { label: "Botón para productos", maxLength: 100 }),
      field("catalog.cards.serviceCtaLabel", SEGMENT_FIELD_TYPES.TEXT, { label: "Botón para servicios", maxLength: 100 }),
      field("catalog.cards.ctaBehavior", SEGMENT_FIELD_TYPES.SELECT, { label: "Destino del botón", options: [
        { value: "detail", label: "Detalle / reserva del ítem" }, { value: "custom", label: "Link personalizado" },
      ], uiGroup: "behavior" }),
      field("catalog.cards.ctaUrl", SEGMENT_FIELD_TYPES.URL, { label: "Link personalizado de las cards", maxLength: URL_MAX_LENGTH }),
      ...globalColorProperties(),
      visualStyleProperty(SEGMENT_TYPES.FEATURED),
    ],
  }),
  [SEGMENT_TYPES.BRANDS]: commonSegment({
    id: SEGMENT_TYPES.BRANDS,
    visibilityPath: "sections.showBrands",
    requiresProducts: true,
    elementEditingReady: true,
    elementTargets: {
      "catalog.brands.ctaLabel": {
        kind: "button",
        label: "Acción de marca",
        labelPath: "catalog.brands.ctaLabel",
        chips: ["Abre catálogo"],
      },
      "@brands.items": {
        kind: "collection-manager",
        label: "Marcas",
        collectionPath: "catalog.brands.items",
        editorMode: "brands",
        chips: ["Hasta 40"],
      },
    },
    shellAdvancedGroups: [
      {
        label: "Mensajes y estados",
        paths: [
          "catalog.brands.loadingText",
          "catalog.brands.emptyText",
          "catalog.brands.errorText",
        ],
      },
    ],
    properties: [
      field("sections.showBrands", SEGMENT_FIELD_TYPES.BOOLEAN, {
        label: "Mostrar marcas",
      }),
      field("catalog.brands.eyebrow", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Texto superior",
        maxLength: 180,
      }),
      field("catalog.brands.title", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Título",
        maxLength: 220,
      }),
      field("catalog.brands.subtitle", SEGMENT_FIELD_TYPES.TEXTAREA, {
        label: "Descripción",
        maxLength: 900,
      }),
      field("catalog.brands.loadingText", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Mensaje de carga",
        maxLength: 220,
      }),
      field("catalog.brands.emptyText", SEGMENT_FIELD_TYPES.TEXTAREA, {
        label: "Mensaje sin marcas",
        maxLength: 300,
      }),
      field("catalog.brands.errorText", SEGMENT_FIELD_TYPES.TEXTAREA, {
        label: "Mensaje de error",
        maxLength: 300,
      }),
      field("catalog.brands.ctaLabel", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Texto del botón",
        maxLength: 100,
      }),
      field("catalog.brands.items", SEGMENT_FIELD_TYPES.COLLECTION, {
        label: "Marcas",
        limits: { maxItems: 40 },
        item: {
          fields: [
            { key: "name", type: SEGMENT_FIELD_TYPES.TEXT, maxLength: 160 },
            { key: "logoUrl", type: SEGMENT_FIELD_TYPES.IMAGE, maxLength: URL_MAX_LENGTH },
            { key: "alt", type: SEGMENT_FIELD_TYPES.TEXT, maxLength: 220 },
            { key: "query", type: SEGMENT_FIELD_TYPES.TEXT, maxLength: 180 },
          ],
        },
      }),
      ...globalColorProperties(),
      visualStyleProperty(SEGMENT_TYPES.BRANDS),
    ],
  }),
  [SEGMENT_TYPES.CATEGORIES]: commonSegment({
    id: SEGMENT_TYPES.CATEGORIES,
    visibilityPath: "sections.showCategories",
    requiresProducts: true,
    elementEditingReady: true,
    shellVisualBackground: false,
    shellVisualPalette: false,
    shellPropertyPaths: [
      "catalog.categories.backgroundColor",
      "catalog.categories.backgroundImageUrl",
      "catalog.categories.backgroundImagePosition",
    ],
    elementTargets: {
      "catalog.categories.ctaLabel": {
        kind: "button",
        label: "Acción de categoría",
        labelPath: "catalog.categories.ctaLabel",
        chips: ["Abre categoría"],
      },
      "@categories.generated": {
        kind: "catalog-derived",
        label: "Categorías automáticas",
        chips: ["Desde tu catálogo"],
      },
      "@categories.item-naming": {
        kind: "catalog-item-naming",
        label: "Cómo llamamos a tus ítems",
        singularPath: "catalog.categories.productSingular",
        pluralPath: "catalog.categories.productPlural",
        chips: ["1 / varios"],
      },
    },
    shellAdvancedGroups: [
      { label: "Mensajes y estados", paths: [
        "catalog.categories.loadingText", "catalog.categories.loadingTextColor", "catalog.categories.loadingSpinnerColor",
        "catalog.categories.emptyText", "catalog.categories.emptyBackgroundColor", "catalog.categories.emptyTextColor", "catalog.categories.emptyBorderColor", "catalog.categories.emptyIconColor",
        "catalog.categories.errorText", "catalog.categories.errorBackgroundColor", "catalog.categories.errorTextColor", "catalog.categories.errorBorderColor", "catalog.categories.errorIconColor",
      ]},
      { label: "Superficie de la card", paths: [
        "catalog.categories.cardBackgroundColor", "catalog.categories.cardBorderColor", "catalog.categories.cardBorderRadius",
        "catalog.categories.cardShadowColor", "catalog.categories.cardShadowOpacity", "catalog.categories.cardShadowX", "catalog.categories.cardShadowY", "catalog.categories.cardShadowBlur", "catalog.categories.cardShadowSpread",
      ]},
      { label: "Imagen", paths: ["catalog.categories.imageFit", "catalog.categories.imagePosition"] },
      { label: "Fallback de imagen", paths: ["catalog.categories.fallbackStartColor", "catalog.categories.fallbackEndColor", "catalog.categories.fallbackAngle"] },
      { label: "Overlay", paths: ["catalog.categories.overlayTopColor", "catalog.categories.overlayMiddleColor", "catalog.categories.overlayBottomColor"] },
      { label: "Título de card", paths: [
        "catalog.categories.cardTitleColor", "catalog.categories.cardTitleShadowColor", "catalog.categories.cardTitleShadowOpacity",
        "catalog.categories.cardTitleShadowX", "catalog.categories.cardTitleShadowY", "catalog.categories.cardTitleShadowBlur",
      ]},
      { label: "Cantidad", paths: ["catalog.categories.countBackgroundColor", "catalog.categories.countTextColor", "catalog.categories.countBorderColor"] },
      { label: "Acción", paths: [
        "catalog.categories.ctaBackgroundColor", "catalog.categories.ctaTextColor", "catalog.categories.ctaHoverBackgroundColor",
        "catalog.categories.ctaHoverTextColor", "catalog.categories.ctaBorderColor", "catalog.categories.ctaBorderRadius",
      ]},
    ],
    properties: [
      field("sections.showCategories", SEGMENT_FIELD_TYPES.BOOLEAN, { label: "Mostrar categorías" }),
      field("catalog.categories.eyebrow", SEGMENT_FIELD_TYPES.TEXT, { label: "Texto superior", colorPath: "catalog.categories.eyebrowColor", maxLength: 180 }),
      field("catalog.categories.title", SEGMENT_FIELD_TYPES.TEXT, { label: "Título", colorPath: "catalog.categories.titleColor", maxLength: 220 }),
      field("catalog.categories.subtitle", SEGMENT_FIELD_TYPES.TEXTAREA, { label: "Descripción", colorPath: "catalog.categories.subtitleColor", maxLength: 900 }),
      field("catalog.categories.loadingText", SEGMENT_FIELD_TYPES.TEXT, { label: "Mensaje de carga", colorPath: "catalog.categories.loadingTextColor", maxLength: 220 }),
      field("catalog.categories.emptyText", SEGMENT_FIELD_TYPES.TEXTAREA, { label: "Mensaje sin categorías", colorPath: "catalog.categories.emptyTextColor", maxLength: 300 }),
      field("catalog.categories.errorText", SEGMENT_FIELD_TYPES.TEXTAREA, { label: "Mensaje de error", colorPath: "catalog.categories.errorTextColor", maxLength: 300 }),
      field("catalog.categories.ctaLabel", SEGMENT_FIELD_TYPES.TEXT, { label: "Texto del botón", maxLength: 100 }),
      field("catalog.categories.productSingular", SEGMENT_FIELD_TYPES.TEXT, { label: "Nombre singular del producto", maxLength: 60 }),
      field("catalog.categories.productPlural", SEGMENT_FIELD_TYPES.TEXT, { label: "Nombre plural del producto", maxLength: 60 }),

      field("catalog.categories.backgroundColor", SEGMENT_FIELD_TYPES.COLOR, { label: "Fondo de la sección", defaultValue: "#EEF0F5", explicitVisual: true, maxLength: 100 }),
      field("catalog.categories.backgroundImageUrl", SEGMENT_FIELD_TYPES.IMAGE, { label: "Imagen de fondo de la sección", maxLength: URL_MAX_LENGTH, positionPath: "catalog.categories.backgroundImagePosition" }),
      field("catalog.categories.backgroundImagePosition", SEGMENT_FIELD_TYPES.SELECT, { label: "Posición del fondo", options: IMAGE_POSITION_OPTIONS }),
      field("catalog.categories.eyebrowColor", SEGMENT_FIELD_TYPES.COLOR, { label: "Color del texto superior", defaultValue: "#F35A3A", explicitVisual: true, maxLength: 100 }),
      field("catalog.categories.titleColor", SEGMENT_FIELD_TYPES.COLOR, { label: "Color del título", defaultValue: "#19242F", explicitVisual: true, maxLength: 100 }),
      field("catalog.categories.subtitleColor", SEGMENT_FIELD_TYPES.COLOR, { label: "Color de la descripción", defaultValue: "#5B5D73", explicitVisual: true, maxLength: 100 }),
      field("catalog.categories.loadingTextColor", SEGMENT_FIELD_TYPES.COLOR, { label: "Color del mensaje de carga", defaultValue: "#5B5D73", explicitVisual: true, maxLength: 100 }),
      field("catalog.categories.loadingSpinnerColor", SEGMENT_FIELD_TYPES.COLOR, { label: "Color del indicador de carga", defaultValue: "#E44E31", explicitVisual: true, maxLength: 100 }),
      field("catalog.categories.emptyBackgroundColor", SEGMENT_FIELD_TYPES.COLOR, { label: "Fondo del estado vacío", defaultValue: "#E5F6FD", explicitVisual: true, maxLength: 100 }),
      field("catalog.categories.emptyTextColor", SEGMENT_FIELD_TYPES.COLOR, { label: "Texto del estado vacío", defaultValue: "#014361", explicitVisual: true, maxLength: 100 }),
      field("catalog.categories.emptyBorderColor", SEGMENT_FIELD_TYPES.COLOR, { label: "Borde del estado vacío", defaultValue: "transparent", explicitVisual: true, maxLength: 100 }),
      field("catalog.categories.emptyIconColor", SEGMENT_FIELD_TYPES.COLOR, { label: "Ícono del estado vacío", defaultValue: "#0288D1", explicitVisual: true, maxLength: 100 }),
      field("catalog.categories.errorBackgroundColor", SEGMENT_FIELD_TYPES.COLOR, { label: "Fondo del error", defaultValue: "#FDEDED", explicitVisual: true, maxLength: 100 }),
      field("catalog.categories.errorTextColor", SEGMENT_FIELD_TYPES.COLOR, { label: "Texto del error", defaultValue: "#5F2120", explicitVisual: true, maxLength: 100 }),
      field("catalog.categories.errorBorderColor", SEGMENT_FIELD_TYPES.COLOR, { label: "Borde del error", defaultValue: "transparent", explicitVisual: true, maxLength: 100 }),
      field("catalog.categories.errorIconColor", SEGMENT_FIELD_TYPES.COLOR, { label: "Ícono del error", defaultValue: "#D32F2F", explicitVisual: true, maxLength: 100 }),
      field("catalog.categories.cardBackgroundColor", SEGMENT_FIELD_TYPES.COLOR, { label: "Fondo de la card", defaultValue: "#F7F8FC", explicitVisual: true, maxLength: 100 }),
      field("catalog.categories.cardBorderColor", SEGMENT_FIELD_TYPES.COLOR, { label: "Borde de la card", defaultValue: "rgba(26,26,46,.09)", explicitVisual: true, maxLength: 100 }),
      field("catalog.categories.cardBorderRadius", SEGMENT_FIELD_TYPES.NUMBER, { label: "Redondez de la card", defaultValue: 14, explicitVisual: true, limits: { min: 0, max: 80, step: 1 }, uiGroup: "design" }),
      field("catalog.categories.cardShadowColor", SEGMENT_FIELD_TYPES.COLOR, { label: "Color de sombra", defaultValue: "#272A40", explicitVisual: true, maxLength: 100 }),
      field("catalog.categories.cardShadowOpacity", SEGMENT_FIELD_TYPES.NUMBER, { label: "Opacidad de sombra", defaultValue: 0.12, explicitVisual: true, limits: { min: 0, max: 1, step: 0.05 }, uiGroup: "design" }),
      field("catalog.categories.cardShadowX", SEGMENT_FIELD_TYPES.NUMBER, { label: "Sombra X", defaultValue: 6, explicitVisual: true, limits: { min: -100, max: 100, step: 1 }, uiGroup: "design" }),
      field("catalog.categories.cardShadowY", SEGMENT_FIELD_TYPES.NUMBER, { label: "Sombra Y", defaultValue: 6, explicitVisual: true, limits: { min: -100, max: 100, step: 1 }, uiGroup: "design" }),
      field("catalog.categories.cardShadowBlur", SEGMENT_FIELD_TYPES.NUMBER, { label: "Difuminado de sombra", defaultValue: 16, explicitVisual: true, limits: { min: 0, max: 160, step: 1 }, uiGroup: "design" }),
      field("catalog.categories.cardShadowSpread", SEGMENT_FIELD_TYPES.NUMBER, { label: "Expansión de sombra", defaultValue: 0, explicitVisual: true, limits: { min: -80, max: 80, step: 1 }, uiGroup: "design" }),
      field("catalog.categories.imageFit", SEGMENT_FIELD_TYPES.SELECT, { label: "Ajuste de imagen", options: [{ value: "cover", label: "Cubrir" }, { value: "contain", label: "Contener" }] }),
      field("catalog.categories.imagePosition", SEGMENT_FIELD_TYPES.SELECT, { label: "Posición de imagen", options: IMAGE_POSITION_OPTIONS }),
      field("catalog.categories.fallbackStartColor", SEGMENT_FIELD_TYPES.COLOR, { label: "Fallback · color inicial", defaultValue: "#494A98", explicitVisual: true, maxLength: 100 }),
      field("catalog.categories.fallbackEndColor", SEGMENT_FIELD_TYPES.COLOR, { label: "Fallback · color final", defaultValue: "#E44E31", explicitVisual: true, maxLength: 100 }),
      field("catalog.categories.fallbackAngle", SEGMENT_FIELD_TYPES.NUMBER, { label: "Fallback · ángulo (°)", defaultValue: 135, explicitVisual: true, limits: { min: 0, max: 360, step: 1 }, uiGroup: "design" }),
      field("catalog.categories.overlayTopColor", SEGMENT_FIELD_TYPES.COLOR, { label: "Overlay superior", defaultValue: "rgba(0,0,0,.14)", explicitVisual: true, maxLength: 100 }),
      field("catalog.categories.overlayMiddleColor", SEGMENT_FIELD_TYPES.COLOR, { label: "Overlay medio", defaultValue: "rgba(0,0,0,.12)", explicitVisual: true, maxLength: 100 }),
      field("catalog.categories.overlayBottomColor", SEGMENT_FIELD_TYPES.COLOR, { label: "Overlay inferior", defaultValue: "rgba(0,0,0,.76)", explicitVisual: true, maxLength: 100 }),
      field("catalog.categories.cardTitleColor", SEGMENT_FIELD_TYPES.COLOR, { label: "Color del título de card", defaultValue: "#FFFFFF", explicitVisual: true, maxLength: 100 }),
      field("catalog.categories.cardTitleShadowColor", SEGMENT_FIELD_TYPES.COLOR, { label: "Color de sombra del título", defaultValue: "#000000", explicitVisual: true, maxLength: 100 }),
      field("catalog.categories.cardTitleShadowOpacity", SEGMENT_FIELD_TYPES.NUMBER, { label: "Opacidad sombra del título", defaultValue: 0.55, explicitVisual: true, limits: { min: 0, max: 1, step: 0.05 }, uiGroup: "design" }),
      field("catalog.categories.cardTitleShadowX", SEGMENT_FIELD_TYPES.NUMBER, { label: "Sombra título X", defaultValue: 0, explicitVisual: true, limits: { min: -100, max: 100, step: 1 }, uiGroup: "design" }),
      field("catalog.categories.cardTitleShadowY", SEGMENT_FIELD_TYPES.NUMBER, { label: "Sombra título Y", defaultValue: 3, explicitVisual: true, limits: { min: -100, max: 100, step: 1 }, uiGroup: "design" }),
      field("catalog.categories.cardTitleShadowBlur", SEGMENT_FIELD_TYPES.NUMBER, { label: "Difuminado sombra título", defaultValue: 14, explicitVisual: true, limits: { min: 0, max: 160, step: 1 }, uiGroup: "design" }),
      field("catalog.categories.countBackgroundColor", SEGMENT_FIELD_TYPES.COLOR, { label: "Fondo de cantidad", defaultValue: "#F35A3A", explicitVisual: true, maxLength: 100 }),
      field("catalog.categories.countTextColor", SEGMENT_FIELD_TYPES.COLOR, { label: "Texto de cantidad", defaultValue: "#FFFFFF", explicitVisual: true, maxLength: 100 }),
      field("catalog.categories.countBorderColor", SEGMENT_FIELD_TYPES.COLOR, { label: "Borde de cantidad", defaultValue: "transparent", explicitVisual: true, maxLength: 100 }),
      field("catalog.categories.ctaBackgroundColor", SEGMENT_FIELD_TYPES.COLOR, { label: "Fondo del CTA", defaultValue: "#F35A3A", explicitVisual: true, maxLength: 100 }),
      field("catalog.categories.ctaTextColor", SEGMENT_FIELD_TYPES.COLOR, { label: "Texto del CTA", defaultValue: "#FFFFFF", explicitVisual: true, maxLength: 100 }),
      field("catalog.categories.ctaHoverBackgroundColor", SEGMENT_FIELD_TYPES.COLOR, { label: "Fondo hover del CTA", defaultValue: "#D94D32", explicitVisual: true, maxLength: 100 }),
      field("catalog.categories.ctaHoverTextColor", SEGMENT_FIELD_TYPES.COLOR, { label: "Texto hover del CTA", defaultValue: "#FFFFFF", explicitVisual: true, maxLength: 100 }),
      field("catalog.categories.ctaBorderColor", SEGMENT_FIELD_TYPES.COLOR, { label: "Borde del CTA", defaultValue: "transparent", explicitVisual: true, maxLength: 100 }),
      field("catalog.categories.ctaBorderRadius", SEGMENT_FIELD_TYPES.NUMBER, { label: "Redondez del CTA", defaultValue: 999, explicitVisual: true, limits: { min: 0, max: 999, step: 1 }, uiGroup: "design" }),
    ],
  }),
};

export default commerceSegments;
